<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
  <search-box @subSearch="subSearch" :fromData="fromData">
    <el-form-item class="item" label="退货单号：" prop="materailVoucherNo">
      <el-input  v-model="fromData.searchCriteria.materailVoucherNo" :placeholder="$store.state.remark.materailVoucherNo"></el-input>
    </el-form-item>
    <el-form-item class="item" label="物料编码：" prop="materialCode">
      <el-input  v-model="fromData.searchCriteria.materialCode" :placeholder="$store.state.remark.matterCode"></el-input>
    </el-form-item>
    <el-form-item class="item" label="物料描述：" prop="materialDesc">
      <el-input  v-model="fromData.searchCriteria.materialDesc" placeholder="请输入物料描述"></el-input>
    </el-form-item>
    <el-form-item class="item time-between" label="选择日期：" prop="searchTime">
      <el-date-picker
        v-model="searchTime"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
    </el-form-item>
  </search-box>
  </el-form>
</template>
<script>
import searchBox from 'components/common/search.vue';
export default{
	props:{
		fromData:Object
	},
	components:{
	  searchBox
	},
	data(){
		return {
      rules: {
        materailVoucherNo:[{message: "",trigger: "blur"}],
        materialCode:[{message: '',trigger: 'change'}]
      },
			getAllPage:{
				"page":1,
				"pageSize":10000
			},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchTime:''
		}
	},
	created(){
    //设置默认日期最近一个月
    const startTime = new Date().getTime() - 3600 * 1000 * 24 * 30;
    const endTime = new Date();
    this.searchTime= [startTime,endTime];
	},
	methods:{
		subSearch(){
      let timeArr = this.searchTime;
      //console.log(timeArr);
      let stime = this.$moment(timeArr[0]).format("YYYY-MM-DD");
      let etime = this.$moment(timeArr[1]).format("YYYY-MM-DD");
      this.fromData.searchCriteria.startDate = stime;
      this.fromData.searchCriteria.endDate = etime;
			this.$emit('subSearch');
		}
  }

}
</script>

<style>
</style>
